ssrAllowed